import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { useThemeModel } from '@entities/theme'
import { IItemsMess } from './../model/types'
import { useCallWaiterModel } from '../model'


export default /*#__PURE__*/_defineComponent({
  __name: 'WaiterChat',
  props: {
  preloaderMessage: {
    type: Boolean as PropType<boolean>,
    required: true,
    default: true
  },
  itemsMess: {
    type: Array as PropType<IItemsMess[]>,
    required: true,
    default: () => []
  },
  isGuidanceRecipientRestaurant: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false
  }
},
  setup(__props) {

const props = __props

const callWaiterModel = useCallWaiterModel()



const themeModel = useThemeModel()

return { __sfc: true,callWaiterModel, props, themeModel }
}

})